module.exports = __webpack_public_path__ + "img/horizontal_3_4_6005.6d3151de.png";